import { useState, useEffect } from 'react';

export const useQuizOptions = (correctValue, dependencies = []) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (correctValue == null) {
      setOptions([]);
      return;
    }

    try {
      // 최소값이 0 이상이 되도록 보정
      const minValue = Math.max(0, Math.floor(correctValue * 0.6));
      const maxValue = Math.max(minValue + 1, Math.ceil(correctValue * 1.3));
      
      // 오답 후보 범위 생성
      const possibleWrongValues = Array.from(
        { length: maxValue - minValue + 1 },
        (_, i) => minValue + i
      ).filter(val => val !== correctValue);

      // 가능한 오답이 3개 미만이면 범위를 확장
      if (possibleWrongValues.length < 3) {
        const expandedValues = Array.from(
          { length: Math.max(6, correctValue * 2) },
          (_, i) => i
        ).filter(val => val !== correctValue);
        
        // 랜덤하게 3개 선택
        const wrongOptions = new Set();
        while (wrongOptions.size < 3 && expandedValues.length > 0) {
          const randomIndex = Math.floor(Math.random() * expandedValues.length);
          wrongOptions.add(expandedValues[randomIndex]);
          expandedValues.splice(randomIndex, 1);
        }
        
        const allOptions = [correctValue, ...Array.from(wrongOptions)];
        setOptions(allOptions.sort(() => Math.random() - 0.5));
        return;
      }

      // 일반적인 경우의 처리
      const wrongOptions = new Set();
      const maxAttempts = 100; // 무한 루프 방지
      let attempts = 0;
      
      while (wrongOptions.size < 3 && attempts < maxAttempts) {
        const randomIndex = Math.floor(Math.random() * possibleWrongValues.length);
        wrongOptions.add(possibleWrongValues[randomIndex]);
        attempts++;
      }

      const allOptions = [correctValue, ...Array.from(wrongOptions)];
      setOptions(allOptions.sort(() => Math.random() - 0.5));
    } catch (error) {
      console.error('Error generating quiz options:', error);
      setOptions([correctValue, correctValue + 1, correctValue + 2, correctValue + 3]);
    }
  }, [correctValue, ...dependencies]);

  return options;
}; 